"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.sendToAnalytics = exports["default"] = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _recompose = require("recompose");

var _webVitals = require("web-vitals");

// For Single Page Apps, prevents initiating vital collection again on new pages which re-mount
var spaHasNotInitiated = true; // For Single Page Apps, prevents accumulating the CLS score as this metric slowly grows as the
// user navigates through the site. It's not until they close or switch browser tabs that the
// score is submitted. Therefore, we enable "reportAllChanges" for CLS and only collect the first.

var needFirstClsScore = true;

var sendToAnalytics = function sendToAnalytics(pageType) {
  return function (metric) {
    var metaData;

    if (metric.name === 'CLS') {
      if (!needFirstClsScore) {
        // Do not accumulate CLS scores, we only care about the initial "page load" score
        return;
      }

      needFirstClsScore = false; // Collect data about the CLS shifts

      metaData = (0, _get2["default"])(metric, 'entries.0.sources', []).map(function (shift) {
        return {
          nodeData: (0, _get2["default"])(shift, 'node.data'),
          nodeName: (0, _get2["default"])(shift, 'node.nodeName'),
          nodeClassName: (0, _get2["default"])(shift, 'node.className'),
          parentNodeClassName: (0, _get2["default"])(shift, 'node.parentNode.className'),
          currentRect: shift.currentRect,
          previousRect: shift.previousRect
        };
      });
    }

    var data = {
      metric: metric.name,
      value: metric.value,
      metaData: metaData,
      pageType: pageType
    };
    var blob = new Blob([JSON.stringify(data)], {
      type: 'text/plain'
    }); // Only send when the browser isn't busy

    navigator.sendBeacon('/api/analytics/corewebvitals', blob);
  };
};

exports.sendToAnalytics = sendToAnalytics;

var _default = (0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    // Do not execute during Server Side Rendering, and only execute on first page load of SPA
    if (typeof window !== 'undefined' && navigator && navigator.sendBeacon && this.props.pageType && spaHasNotInitiated) {
      (0, _webVitals.getCLS)(sendToAnalytics(this.props.pageType), true);
      (0, _webVitals.getFID)(sendToAnalytics(this.props.pageType));
      (0, _webVitals.getLCP)(sendToAnalytics(this.props.pageType));
      spaHasNotInitiated = false;
    }
  }
});

exports["default"] = _default;